import http from "./http-common";

class ModuleService {

    
    
    async getModules() {
        const response = await http.get("/Module/GetModules");
        var data = response.data;
        return data;
    }

    async addModule(name) {
        let formData = new FormData();
        formData.append('name', name);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/Module/AddModule", formData, config);
        var data = response.data;
        return data;
    }

    async updateModule(moduleid, name) {
        let formData = new FormData();
        formData.append('moduleid', moduleid);
        formData.append('name', name);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/Module/UpdateModule", formData, config);
        var data = response.data;
        return data;
    }

    async deleteModule(moduleid) {
        const response = await http.get("/Module/DeleteModule?moduleid=" + moduleid);
        var data = response.data;
        return data;
    }

    async addSubSection(moduleid, parentid, name, resourceName, color, selectedcolor, textContent, sortIndex, component) {
        let formData = new FormData();
        formData.append('moduleid', moduleid);
        formData.append('parentid', parentid);
        formData.append('name', name);
        formData.append('resourceName', resourceName);
        formData.append('color', color);
        formData.append('selectedcolor', selectedcolor);
        formData.append('textContent', textContent);
        formData.append('sortIndex', sortIndex);
        formData.append('component', component);

        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/Module/AddSubSection", formData, config);
        var data = response.data;
        return data;
    }

    async updateSubSection(subsectionid, name, resourceName, color, selectedcolor, textContent, sortIndex, component, parentId) {
        let formData = new FormData();
        formData.append('subsectionid', subsectionid);
        formData.append('name', name);
        formData.append('resourceName', resourceName);
        formData.append('color', color);
        formData.append('selectedcolor', selectedcolor);
        formData.append('textContent', textContent);
        formData.append('sortIndex', sortIndex);
        formData.append('component', component);
        formData.append('parentId', parentId);
        alert("parentId:" + parentId)
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/Module/UpdateSubSection", formData, config);
        var data = response.data;
        return data;
    }

    async deleteSubSection(subsectionid) {
        const response = await http.get("/Module/DeleteSubSection?subsectionid=" + subsectionid);
        var data = response.data;
        return data;
    }
}

export default new ModuleService();
